export const journeyData = {
      title:"Ready to Start Your Journey",
      desc:"Embark on a digital adventure with [Company Name]. Whether you're a startup with a bold idea or an established business looking to innovate, we're here to turn your vision into reality. Let's create something amazing together!",
      btn:"Book a call"
} 